import type { M365Acquisition } from "owa-graph-schema";
import { hasAddin } from "./hasAddin";

export function getExtensionId(acquisition: M365Acquisition): string {
    const extensionId = hasAddin(acquisition)
        ? (acquisition.manifestId ?? "")
        : (acquisition.appId ?? "");
    return extensionId.toLowerCase();
}
